var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M6 9.99816H10.5M8.25 1.74816C8.44891 1.54925 8.7187 1.4375 9 1.4375C9.13929 1.4375 9.27721 1.46493 9.4059 1.51824C9.53458 1.57154 9.65151 1.64967 9.75 1.74816C9.84849 1.84665 9.92662 1.96358 9.97992 2.09226C10.0332 2.22095 10.0607 2.35887 10.0607 2.49816C10.0607 2.63745 10.0332 2.77537 9.97992 2.90406C9.92662 3.03274 9.84849 3.14967 9.75 3.24816L3.5 9.49816L1.5 9.99816L2 7.99816L8.25 1.74816Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit2);
export default __webpack_public_path__ + "static/media/edit-2.ba354342a11c4cf7680b4d4615f7f823.svg";
export { ForwardRef as ReactComponent };